import { useEffect, useRef } from 'react'

export interface UseKeyInputPINEventHandler {
    onNumberKeyPress?: (key: string) => void
    onBackspacePress?: () => void
    onEnterPress?: () => void
}

const useKeyInputPIN = (isEnabled: boolean) => {
    const handler = useRef<UseKeyInputPINEventHandler>(null)

    useEffect(() => {
        if (isEnabled) {
            const onKeyDownHandler = (ev: any) => {
                if ('0123456789'.indexOf(ev.key) > -1)
                    handler.current?.onNumberKeyPress?.(ev.key)
                else if (ev.key === 'Enter') handler.current?.onEnterPress?.()
                else if (ev.key === 'Backspace')
                    handler.current?.onBackspacePress?.()
            }

            window.addEventListener('keydown', onKeyDownHandler)

            return () => {
                window.removeEventListener('keydown', onKeyDownHandler)
            }
        }
    }, [isEnabled])

    return { keyInputRef: handler }
}

export default useKeyInputPIN
